module.exports = __webpack_public_path__ + "static/Crawling_Claw-d8efddfc4a2328800401f5576420c695.jpg";